var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ed-select-tabs bsx-d-flex rounded-3 border bsx-overflow-hidden"},_vm._l((_vm.items),function(item){return _c('button',{key:item.value,staticClass:"bsx-py-2 bsx-px-4 bsx-overflow-hidden fs-sm",class:{
      active: item.value === _vm.selected.value
    },on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v(" "+_vm._s(_vm.$t(item.label))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }